module.exports = __webpack_public_path__ + "img/img-dados-bancarios.ac1d8a64.png";